import { client } from '../api/client'
import { AnnouncementsData, Labour, Schedule } from '../types/labourTypes'

/**
 * Home app data
 *
 * @returns Promise<Labour>
 */

const fetchData = (UserKey: number): Promise<Labour> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Employee/GetUserEmployeeByUserKey/${UserKey}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const schedulefetchData = (
  Id: number,
  from: string,
  to: string
): Promise<Schedule> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Shift/GetAllShift?userId=${Id}&fromDate=${from}&toDate=${to}`
      )
      if (response.status === 200) {
        // const data={...response.data,shiftInfo:updatedData}

        //    resolve(data)
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const announcementsfetchData = (
  entity: number,
  storeid: number,
  corpid: number
): Promise<AnnouncementsData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetEssAnnouncement?EntityId=${entity}&StoreId=${storeid}&CorpId=${corpid}`
      )
      //const response =await client.get(`OnBoarding/GetEssAnnouncement?EntityId=1&CorpId=378`)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getNotification = (id: number): Promise<AnnouncementsData> => {
  return new Promise(async (resolve, reject) => {
    try {
      // const response = await client.get(
      //   `/OnBoarding/GetNotifications?essUserkey=${id}`
      // )
      const response = await client.get(
        `/OnBoarding/GetNewNotifications?essUserkey=${id}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getNotificationDetails = (id: number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetNotificationShiftInfo?ShiftKeyNavigation=${id}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const updateNotificationStatus = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/UpdateNotificationAsViewed`,
        { notificationKey: id }
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const markallasread = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(
        `OnBoarding/UpdateNotificationStatus`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const switchaccount = (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetMultiAccountLogins?EmailAddress=${email}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const getDaysOrder = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetCalendarStartDay?EssUserKey=${id}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getTimeClockId = (userId: number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetTimeClockId?UserId=${userId}`
      )
      if (response.status == 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const labourService = {
  fetchData,
  schedulefetchData,
  announcementsfetchData,
  getNotification,
  updateNotificationStatus,
  getNotificationDetails,
  markallasread,
  switchaccount,
  getDaysOrder,
  getTimeClockId
}
